import React, { PureComponent } from 'react';
import { Button, Segment, Sidebar, Icon, Rail, Popup } from 'semantic-ui-react';

class AdPreviewCommonToolsSidebar extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showPanel: false,
      currentPanelHeight: 0,
      toolPanelHeight: 0
    };
  }

  componentDidMount() {
    this.initialize();
  }

  initialize = () => {
    const toolPanelHeight = this.getToolPanelHeight();
    this.setState(
      (prevState) => ({
        ...prevState,
        toolPanelHeight
      }),
      () => {
        document.getElementById('sideBar').style.display = 'none';
      }
    );
  };

  showToolPanel = () => {
    const { showPanel } = this.state;
    this.setState(
      (prevState) => ({
        ...prevState,
        showPanel: !showPanel
      }),
      () => {
        const sidebar = document.getElementById('sideBar');
        if (sidebar) {
          sidebar.style.transition = 'display 0.45s ease-out';
          const displayStyle = this.state.showPanel ? '' : 'none';
          sidebar.style.display = displayStyle;
        }
      }
    );
  };

  getToolPanelHeight = () => {
    return document.getElementById('sideBar')
      ? document.getElementById('sideBar').clientHeight
      : 0;
  };

  render() {
    const { showPanel, toolPanelHeight } = this.state;
    const { renderSidebarContent } = this.props;

    return (
      <div>
        <Rail position="right">
          <div
            style={
              showPanel
                ? {
                    transition: 'bottom 0.05s ease-out',
                    bottom: `${toolPanelHeight - 4}px`
                  }
                : {
                    transition: 'bottom 0.05s ease-out',
                    bottom: '0px'
                  }
            }
            className="sticky-tools"
          >
            <Button
              className="sticky-button sticky-button-hidden"
              color="blue"
              size="small"
              onClick={this.props.scrollToTop}
            >
              <Icon name="arrow alternate circle up" />
            </Button>
            <Popup
              trigger={
                <Button
                  color="purple"
                  size="small"
                  onClick={this.showToolPanel}
                >
                  <Icon name="wrench" />
                </Button>
              }
              on="hover"
              content="You click here to open the tool panel."
              position="top right"
            />
          </div>
        </Rail>
        <div>
          <Sidebar
            id="sideBar"
            as={Segment}
            animation={'overlay'}
            direction={'bottom'}
            visible={showPanel}
          >
            {renderSidebarContent ? renderSidebarContent() : null}
          </Sidebar>
        </div>
      </div>
    );
  }
}

export default AdPreviewCommonToolsSidebar;



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationComponents/AdPreviewCommonToolsSidebar.js